import {Injector, Type} from '@angular/core';
import {
    TablePlugin,
    TablePluginColumnCellMovedArgs,
    TablePluginColumnCellRemovedArgs,
    TablePluginColumnCellRenderedArgs,
    TablePluginColumnConfigAddedArgs,
    TablePluginColumnConfigIdentityChangedArgs,
    TablePluginColumnsSetupArgs,
    TablePluginConfigMovedArgs,
    TablePluginInitTablePluginArgs
} from './table-plugin';

export class TablePluginsDelegate implements TablePlugin {

    private tablePlugins: TablePlugin[];

    constructor(
        private injector: Injector,
        private pluginClasses: Array<Type<TablePlugin>>
    ) {
        this.tablePlugins = this.pluginClasses.map(
            pluginClass => new pluginClass(this.injector)
        );
    }

    public initTablePlugin(args: TablePluginInitTablePluginArgs): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.initTablePlugin) {
                tablePlugin.initTablePlugin(args);
            }
        });
    }

    public columnsSetup(args: TablePluginColumnsSetupArgs): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.columnsSetup) {
                tablePlugin.columnsSetup(args);
            }
        });
    }

    public tableReady(): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.tableReady) {
                tablePlugin.tableReady();
            }
        });
    }

    public finalizeColumnsConfigChanges(): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.finalizeColumnsConfigChanges) {
                tablePlugin.finalizeColumnsConfigChanges();
            }
        });
    }

    public finalizeCellsRendering(): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.finalizeCellsRendering) {
                tablePlugin.finalizeCellsRendering();
            }
        });
    }

    public columnConfigAdded(args: TablePluginColumnConfigAddedArgs): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.columnConfigAdded) {
                tablePlugin.columnConfigAdded(args);
            }
        });
    }

    public columnConfigRemoved(adjustedPreviousIndex: number): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.columnConfigRemoved) {
                tablePlugin.columnConfigRemoved(adjustedPreviousIndex);
            }
        });
    }

    public columnConfigMoved(args: TablePluginConfigMovedArgs): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.columnConfigMoved) {
                tablePlugin.columnConfigMoved(args);
            }
        });
    }

    public columnConfigIdentityChanged(args: TablePluginColumnConfigIdentityChangedArgs): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.columnConfigIdentityChanged) {
                tablePlugin.columnConfigIdentityChanged(args);
            }
        });
    }

    public columnCellRemoved(args: TablePluginColumnCellRemovedArgs): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.columnCellRemoved) {
                tablePlugin.columnCellRemoved(args);
            }
        });
    }

    public onColumnCellMoved(args: TablePluginColumnCellMovedArgs): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.onColumnCellMoved) {
                tablePlugin.onColumnCellMoved(args);
            }
        });
    }

    public columnCellRendered(args: TablePluginColumnCellRenderedArgs): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.columnCellRendered) {
                tablePlugin.columnCellRendered(args);
            }
        });
    }

    public rowRemoved(adjustedTableRowIndex: number): void {
        this.tablePlugins.forEach(tablePlugin => {
            if (tablePlugin.rowRemoved) {
                tablePlugin.rowRemoved(adjustedTableRowIndex);
            }
        });
    }

}
